const e = "header", r = "header__logo", _ = "header__actions", a = "header__worldwide", d = "header__search", h = "header__burger", o = {
  header: e,
  "header__skip-link": "header__skip-link",
  "header__first-row": "header__first-row",
  "header__second-row": "header__second-row",
  header__logo: r,
  "header__logo-image": "header__logo-image",
  "header__logo-link": "header__logo-link",
  header__actions: _,
  header__worldwide: a,
  header__search: d,
  "header__search--active": "header__search--active",
  "header__search-icon": "header__search-icon",
  header__burger: h,
  "header__worldwide-icon": "header__worldwide-icon",
  "header__burger-icon": "header__burger-icon",
  "header__mobile-nav": "header__mobile-nav",
  "header__secondary-nav": "header__secondary-nav",
  "header--scrolled": "header--scrolled",
  "header--transparent": "header--transparent",
  "header--hidden": "header--hidden"
};
export {
  o as default,
  e as header,
  _ as header__actions,
  h as header__burger,
  r as header__logo,
  d as header__search,
  a as header__worldwide
};
